import { Infobox } from 'Atoms';
import { TimePeriods, TimePeriodsEnums } from 'containers/Esrs/pieces';

const FULL_YEAR_VIEW_DESCRIPTION =
  'You are looking now at the full year view. Some metrics in this disclosure requirement are collected quarterly — to see data per quarter, switch between views above.';
const QUARTERLY_VIEW_DESCRIPTION =
  'You are looking now at metrics collected quarterly. To see the full year overview and narrative data points, switch to the "Full year" view above.';

export const MetricsQuarterInfo = ({ selectedQuarter }: { selectedQuarter: TimePeriods }) => {
  const title =
    selectedQuarter === TimePeriodsEnums.year
      ? 'Full year view'
      : `Quarter view: ${selectedQuarter}`;
  const description =
    selectedQuarter === TimePeriodsEnums.year
      ? FULL_YEAR_VIEW_DESCRIPTION
      : QUARTERLY_VIEW_DESCRIPTION;

  return (
    <Infobox status="neutral" closable={false} w="100%" title={title} description={description} />
  );
};
